// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1893": "2d7ac63a3c77","3616": "2bd20f1d2224","3855": "da5bfd638b1f","6863": "454c9f289029",}[chunkId] + ".css"
}